import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { StateService } from "../../../core/state/state.service";
import { AdvisorData, AdvisorState } from "../advisor.model";

const initialState: AdvisorState = { data: {}};

@Injectable({
  providedIn: "root",
})
export class AdvisorStateService extends StateService<AdvisorState> {
  constructor() {
    super(initialState);
  }

  getAdvisor$(advisorId: number): Observable<AdvisorData> {
    return this.select((state) => state.data[advisorId]);
  }

  setAdvisor(advisorId: number, advisor: AdvisorData): void {
    const newState = {
      ...this.state,
      data: {
        ...this.state.data,
        [advisorId]: advisor,
      }
    };
    this.setState(newState);
  }

  isAdvisorLoaded(advisorId: number): boolean {
    return !!this.state.data[advisorId];
  }

  clearState(): void {
    this.initState(initialState);
  }
}